export default {
  label: {
    tooltip: 'Essa pesquisa pertence ao ambiente de teste (staging)',
    environment: 'Staging',
  },
};
